import {Actions} from '../messageBox/actions';

export const buildErrorMessage = (error) => {
  const newLine = String.fromCharCode(13, 10);
  const descriptionError = Array.isArray(error.data.type) ? error.data.type.join(newLine) : error.data.type;
  let errorMessage = `${error.data.code} - ${descriptionError}`;

  if (error.data.error) {
    errorMessage += ` - ${error.data.error}`;
  }

  return Actions.addMessageBoxError(errorMessage);
};

export const buildSuccessMessage = (response, defaultMessage) => {
  const apiMessage = response.data && response.data.message;
  const newLine = String.fromCharCode(13, 10);
  const descriptionApiMessage = Array.isArray(apiMessage) ? apiMessage.join(newLine) : apiMessage;

  const message = apiMessage ? descriptionApiMessage : defaultMessage;

  return Actions.addMessageBoxInfo(message);
};
